module.exports = __webpack_public_path__ + "fonts/ionicons.a558ac78.eot";